// @flow

import { createStore, Provider } from 'unistore/full/preact.es';

import App from './App';
import { Modes } from './appConstants';

const initialState = {
  accountMode: Modes.SignedOut,
  profile: {},
  accessToken: '',
  event: ''
};

let store = createStore(initialState);

if (process.env.NODE_ENV === 'development') {
  const devtools = require('unistore/devtools');
  store = devtools(store);
}

const AppWrapper = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default AppWrapper;



// WEBPACK FOOTER //
// ./components/AppWrapper.js